/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ExpenseApi } from '../api/expenses.api';
import { switchMap, map } from 'rxjs/operators';
import { ExpenseData, Expense } from '../../../interfaces/masters/expense';

@Injectable()
export class ExpenseService extends ExpenseData {

  constructor(private api: ExpenseApi) {
    super();
  }

  list(url: string): Observable<Expense[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Expense>{
      return this.api.getById(url);
  }

  create(url: string, data:Expense): Observable<Expense> {
    return this.api.add(url,data);
  }

  update(url: string, data:Expense): Observable<Expense> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
